// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.row-flex {
  display: flex;
  flex-wrap: wrap;
}

.select-metric-option {
  display: flex;
  gap: 1rem;
  align-items: baseline;
  justify-content: flex-start;
}

.metric-select {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
}

.metric-select h4 {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1rem;
  color: #0d47a0;
}

.message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.btn-primary.next-btn {
  max-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

legend {
  border: 1px solid #bfbfbf;
  border-radius: 8px;
}

.weight-body {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.create-theme {
  height: 100%;
  display: block;
  padding: 0.5rem;
  overflow: hidden;
}
.create-theme fieldset {
  height: 100%;
  width: 100%;
  display: block;
  position: relative;
}

.theme-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.final-metrics-container {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: scroll;
}

.final-metrics {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  color: #2f2f2f;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.form-select {
  text-align: left;
}

.form-select.btn {
  text-align: left !important;
  border: 1px solid #e4e8e9;
  background-color: white;
}
.form-select.btn:hover {
  background-color: #fff;
}

.dropdown-toggle::after {
  content: none !important;
}

.dropdown-checkbox {
  margin-right: 0.5rem;
}

.selected-languages {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 330px;
  overflow-y: scroll;
}

.selected-metrics {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: space-between;
  margin: 0;
  list-style-type: disc;
  list-style-position: inside;
}

.metric-group-expanded {
  display: block;
  background: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  margin: 8px 2px;
  border-radius: 20px 20px 8px 8px;
  transition: all 0.2s ease-in;
  padding-bottom: 8px;
}

.metric-group-collapsed {
  display: block;
  margin: 8px 2px;
  border-radius: 20px 20px 8px 8px;
  box-shadow: none;
  background: transparent;
  transition: all 0.3s ease-out;
}

.metric-list {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  line-height: 1.5;
  color: #333;
  font-size: 13px;
  list-style: decimal;
}

.group-name {
  font-size: 14px;
  line-height: 1.2;
  color: #2f2f2f;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}

.group-name-heading {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  color: #0d47a0;
  margin-bottom: 2px;
}

.action-items {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.weights-value {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 13px;
  width: max-content;
  background-color: #0d47a0;
  border-color: #0d47a0;
  color: #fff;
  display: flex;
  padding: 4px 8px;
  border-radius: 3px;
}

.expand-details {
  color: #262b3f;
  line-height: 1;
  padding: 4px;
  display: block;
  width: 32px;
  height: 32px;
  aspect-ratio: 1;
  cursor: pointer;
}

.theme-btn-collapsed {
  display: flex;
  justify-content: space-between;
  border: 1px solid #e4e8e9;
  padding: 4px 12px 4px 16px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: all 0.35s ease-in-out;
  align-items: center;
  flex: 1 1 auto;
}

.theme-btn-expanded {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px 4px 16px;
  transition: all 0.5s ease-in-out;
}

.metrics-list {
  display: block;
  padding-left: 12px;
}

.theme-status-overflow {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.75);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.group-td:even {
  background-color: #fff;
}

@media (max-width: 1179px) {
  .select-metric-option .Select-input {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .select-metric-option .Select-input {
    width: 100%;
  }
  .select-metric-option {
    flex-direction: column;
  }
  .select-metric-option .multi-select-dropdown {
    width: 100%;
    max-width: 100%;
    min-width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/components/SuperThemes/SuperThemes.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA3EA;EACE,aAAA;EACA,eAAA;AA8EF;;AA5EA;EACE,aAAA;EACA,SAAA;EACA,qBAAA;EACA,2BAAA;AA+EF;;AA7EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAgFF;;AA9EA;EDWE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECZA,eAAA;EACA,cEpBc;AFwGhB;;AAlFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AAqFF;;AAnFA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAsFF;;AApFA;EACE,yBAAA;EACA,kBAAA;AAuFF;;AArFA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAwFF;;AAtFA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAyFF;AAxFE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AA0FJ;;AAvFA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AA0FF;;AAxFA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA2FF;;AAzFA;EDlDE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECiDA,cErEW;EFsEX,cAAA;EACA,qBAAA;AA+FF;;AA7FA;EACE,gBAAA;AAgGF;;AA9FA;EACE,2BAAA;EACA,yBAAA;EACA,uBAAA;AAiGF;AAhGE;EACE,sBElFI;AFoLR;;AA/FA;EACE,wBAAA;AAkGF;;AAhGA;EACE,oBAAA;AAmGF;;AAjGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAoGF;;AAlGA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,2BAAA;AAqGF;;AAnGA;EACE,cAAA;EACA,gBAAA;EACA,wFAAA;EAEA,eAAA;EACA,gCAAA;EACA,4BAAA;EACA,mBAAA;AAqGF;;AAnGA;EACE,cAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;AAsGF;;AAnGA;ED5GE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC2GA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAyGF;;AAvGA;EACE,eAAA;EACA,gBAAA;EACA,cEvIW;EFwIX,aAAA;EACA,8BAAA;EACA,YAAA;AA0GF;;AAxGA;EDrHE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECoHA,mBAAA;EACA,cEpJc;EFqJd,kBAAA;AA8GF;;AA5GA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;AA+GF;;AA7GA;EDhIE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC+HA,eAAA;EACA,kBAAA;EACA,yBEhKc;EFiKd,qBEjKc;EFkKd,WE9JM;EF+JN,aAAA;EACA,gBAAA;EACA,kBAAA;AAmHF;;AAjHA;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAoHF;;AAlHA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,wFAAA;EAEA,iCAAA;EACA,mBAAA;EACA,cAAA;AAoHF;;AAlHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;AAqHF;;AAlHA;EACE,cAAA;EACA,kBAAA;AAqHF;;AAlHA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAqHF;;AAnGA;EACE;IACE,uBAAA;EAsGF;EApGA;IACE,yBAAA;EAsGF;AACF;AAnGA;EACE,sBE1OM;AF+UR;;AAlGA;EACE;IACE,UAAA;EAqGF;AACF;AAnGA;EACE;IACE,WAAA;EAqGF;EAnGA;IACE,sBAAA;EAqGF;EAnGA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;EAqGF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.row-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.select-metric-option {\n  display: flex;\n  gap: 1rem;\n  align-items: baseline;\n  justify-content: flex-start;\n}\n\n.metric-select {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem 0;\n}\n\n.metric-select h4 {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 1rem;\n  color: #0d47a0;\n}\n\n.message-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.btn-primary.next-btn {\n  max-width: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\nlegend {\n  border: 1px solid #bfbfbf;\n  border-radius: 8px;\n}\n\n.weight-body {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.create-theme {\n  height: 100%;\n  display: block;\n  padding: 0.5rem;\n  overflow: hidden;\n}\n.create-theme fieldset {\n  height: 100%;\n  width: 100%;\n  display: block;\n  position: relative;\n}\n\n.theme-content {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n}\n\n.final-metrics-container {\n  display: flex;\n  flex-direction: column;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.final-metrics {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  color: #2f2f2f;\n  line-height: 1;\n  margin-bottom: 0.5rem;\n}\n\n.form-select {\n  text-align: left;\n}\n\n.form-select.btn {\n  text-align: left !important;\n  border: 1px solid #e4e8e9;\n  background-color: white;\n}\n.form-select.btn:hover {\n  background-color: #fff;\n}\n\n.dropdown-toggle::after {\n  content: none !important;\n}\n\n.dropdown-checkbox {\n  margin-right: 0.5rem;\n}\n\n.selected-languages {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 330px;\n  overflow-y: scroll;\n}\n\n.selected-metrics {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: space-between;\n  margin: 0;\n  list-style-type: disc;\n  list-style-position: inside;\n}\n\n.metric-group-expanded {\n  display: block;\n  background: #fff;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  margin: 8px 2px;\n  border-radius: 20px 20px 8px 8px;\n  transition: all 0.2s ease-in;\n  padding-bottom: 8px;\n}\n\n.metric-group-collapsed {\n  display: block;\n  margin: 8px 2px;\n  border-radius: 20px 20px 8px 8px;\n  box-shadow: none;\n  background: transparent;\n  transition: all 0.3s ease-out;\n}\n\n.metric-list {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 1.5;\n  color: #333;\n  font-size: 13px;\n  list-style: decimal;\n}\n\n.group-name {\n  font-size: 14px;\n  line-height: 1.2;\n  color: #2f2f2f;\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.group-name-heading {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  color: #0d47a0;\n  margin-bottom: 2px;\n}\n\n.action-items {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.weights-value {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 13px;\n  width: max-content;\n  background-color: #0d47a0;\n  border-color: #0d47a0;\n  color: #fff;\n  display: flex;\n  padding: 4px 8px;\n  border-radius: 3px;\n}\n\n.expand-details {\n  color: #262b3f;\n  line-height: 1;\n  padding: 4px;\n  display: block;\n  width: 32px;\n  height: 32px;\n  aspect-ratio: 1;\n  cursor: pointer;\n}\n\n.theme-btn-collapsed {\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #e4e8e9;\n  padding: 4px 12px 4px 16px;\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  transition: all 0.35s ease-in-out;\n  align-items: center;\n  flex: 1 1 auto;\n}\n\n.theme-btn-expanded {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 12px 4px 16px;\n  transition: all 0.5s ease-in-out;\n}\n\n.metrics-list {\n  display: block;\n  padding-left: 12px;\n}\n\n.theme-status-overflow {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.75);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.group-td:even {\n  background-color: #fff;\n}\n\n@media (max-width: 1179px) {\n  .select-metric-option .Select-input {\n    width: 50%;\n  }\n}\n@media (max-width: 767px) {\n  .select-metric-option .Select-input {\n    width: 100%;\n  }\n  .select-metric-option {\n    flex-direction: column;\n  }\n  .select-metric-option .multi-select-dropdown {\n    width: 100%;\n    max-width: 100%;\n    min-width: 120px;\n  }\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
